import cookies from './util.cookies';
import log from './util.log';
import db from './util.db';
import Vue from 'vue'

import Setting from '@/setting';

const util = {
    cookies,
    log,
    db,
    getmsg
};

function tTitle (title = '') {
    if (window && window.$t) {
        if (title.indexOf('$t:') === 0) {
            return window.$t(title.split('$t:')[1]);
        } else {
            return title;
        }
    } else {
        return title;
    }
}
function getmsg (component,key,key1) {
    key1 = key1 ? key1 : ''
    var lang = component.$store.state.admin.i18n.locale
    return lang === 'zh-CN' ? $t('ERR-000') + $t(key) + $t(key1) : lang === 'ja-JP' ? $t(key) + $t(key1) + $t('ERR-000') : 'Please enter' + $t(key) + $t(key1)
}
/**
 * @description 更改标题
 * @param {Object} title 标题
 * @param {Object} count 未读消息数提示（可视情况选择使用或不使用）
 */
util.title = function ({ title, count }) {
    title = tTitle(title);
    let fullTitle = title ? `${title} - ${Setting.titleSuffix}` : Setting.titleSuffix;

    if (count) fullTitle = `(${count}条消息)${fullTitle}`;
    window.document.title = fullTitle;
};

function requestAnimation (task) {
    if ('requestAnimationFrame' in window) {
        return window.requestAnimationFrame(task);
    }

    setTimeout(task, 16);
}



util.JsonUtil = {
    //定义换行符
    n : "\n",
    //定义制表符
    t : "\t",
    //转换String
    convertToString : function(obj) {
        return JsonUtil.__writeObj(obj, 1);
    },
    //写对象
    __writeObj : function(obj //对象
            , level //层次（基数为1）
            , isInArray) { //此对象是否在一个集合内
        //如果为空，直接输出null
        if (obj == null) {
            return "null";
        }
        //为普通类型，直接输出值
        if (obj.constructor == Number || obj.constructor == Date
                || obj.constructor == String || obj.constructor == Boolean) {
            var v = obj.toString();
            var tab = isInArray
                    ? JsonUtil.__repeatStr(JsonUtil.t, level - 1)
                    : "";
            if (obj.constructor == String || obj.constructor == Date) {
                //时间格式化只是单纯输出字符串，而不是Date对象
                return tab + ("\"" + v + "\"");
            } else if (obj.constructor == Boolean) {
                return tab + v.toLowerCase();
            } else {
                return tab + (v);
            }
        }

        //写Json对象，缓存字符串
        var currentObjStrings = [];
        //遍历属性
        for (var name in obj) {
            var temp = [];
            //格式化Tab
            var paddingTab = JsonUtil.__repeatStr(JsonUtil.t, level);
            temp.push(paddingTab);
            //写出属性名
            temp.push(name + " : ");

            var val = obj[name];
            if (val == null) {
                temp.push("null");
            } else {
                var c = val.constructor;

                if (c == Array) { //如果为集合，循环内部对象
                    temp.push(JsonUtil.n + paddingTab + "[" + JsonUtil.n);
                    var levelUp = level + 2; //层级+2

                    var tempArrValue = []; //集合元素相关字符串缓存片段
                    for (var i = 0; i < val.length; i++) {
                        //递归写对象
                        tempArrValue.push(JsonUtil.__writeObj(val[i], levelUp,
                                true));
                    }

                    temp.push(tempArrValue.join("," + JsonUtil.n));
                    temp.push(JsonUtil.n + paddingTab + "]");
                } else if (c == Function) {
                    temp.push(val);
                } else {
                    //递归写对象
                    temp.push(JsonUtil.__writeObj(val, level + 1));
                }
            }
            //加入当前对象“属性”字符串
            currentObjStrings.push(temp.join(""));
        }
        return (level > 1 && !isInArray ? JsonUtil.n : "") //如果Json对象是内部，就要换行格式化
                + JsonUtil.__repeatStr(JsonUtil.t, level - 1) + "{" + JsonUtil.n //加层次Tab格式化
                + currentObjStrings.join("," + JsonUtil.n) //串联所有属性值
                + JsonUtil.n + JsonUtil.__repeatStr(JsonUtil.t, level - 1) + "}"; //封闭对象
    },
    __isArray : function(obj) {
        if (obj) {
            return obj.constructor == Array;
        }
        return false;
    },
    __repeatStr : function(str, times) {
        var newStr = [];
        if (times > 0) {
            for (var i = 0; i < times; i++) {
                newStr.push(str);
            }
        }
        return newStr.join("");
    },
    parseToJson : function ( jsonStr , type ) {

        type = type || 1;
        if ( typeof jsonStr == "object" ) {
            return jsonStr;
        }
        if ( jsonStr === "" )
            return;
        try {
            switch ( type ) {
                case 1 :
                    return eval ( "(" + jsonStr + ")" );
                break;
                case 2 :
                    return $.parseJSON ( jsonStr );
                break;
                case 3 :
                    return angular.fromJson ( jsonStr );
                break;
                case 4 :
                    return JSON.parse ( jsonStr );
                break;
                default :
                    // console.error ( "解析json对象错误" );
                break;
            }

        } catch ( e ) {
            return JsonUtil.parseToJson ( jsonStr , type + 1 );
        }
    } ,
    ps : function ( jsonStr , type ) {

        return this.parseToJson ( jsonStr , type );
    } ,
    //通过普通的字符串 获取json对象
    getJs : function(txt,time){
          time = time||0;
          if(time>=2) return txt;
          var oldTxt = txt.replaceAll("\n"," ").replaceAll("\r"," ");
          txt = "\""+txt+"\"";
          txt = txt.replaceAll(" ","").replaceAll("\n"," ").replaceAll("\r"," ");
          txt = txt.replaceAll("\s","");
          txt = txt.replaceAll("：",":").replaceAll("=",":").replaceAll("-",":").replaceAll("\\.",":");
          txt = txt.replaceAll(":","\":\"");
          txt = txt.replaceAll("；",";");
          txt = txt.replaceAll("，",",");
          txt = txt.replaceAll(",","\",\"");
          txt = txt.replaceAll(";","\",\"");
          var match = txt.match(/\d+/ig);
          if(match){
              var firstNum = match[0];
              var firstNumIndex = txt.indexOf(firstNum);
              if(firstNumIndex>2){
                  txt = "\""+txt.substring(firstNumIndex,txt.length);
              }
          }
          txt = "{"+txt+"}";
          if(!this.ps(txt)){
              txt = txt.replaceAll("，",",");
              txt = txt.replaceAll(",","\",\"");
              if(!this.ps(txt) ){
                  txt = oldTxt.split(" ").join(",").replace(/,,*/img,",");
                  return this.getJs(txt,++time);
              }

          }
          return JSON.stringify(this.ps(txt));
    },
};

/**
 * 字符串替换
 *
 * @param s1
 *            需要替换的字符
 * @param s2
 *            替换的字符。
 * @returns
 */
String.prototype.replaceAll = function(s1, s2) {
    return this.replace(new RegExp(s1, "gm"), s2);
};
// 驼峰
String.prototype.tuoFeng = function ( ) {

    return this.replace ( /(\_|\-)(\w)/g , function ( x ) {

        return x.slice ( 1 ).toUpperCase ( );
    } );
}

// 首字母大写的驼峰
String.prototype.tuoFengCap = function ( ) {
    var tempStr = this.tuoFeng();
    return tempStr.substring(0,1).toUpperCase()+tempStr.substring(1,tempStr.length);
}

window.getDic = function(dictKey,fn){
      let url = "/sys/dataDict/getDictData";
      let post =  Vue.abHttpUtil.post(url, {
          dictKey : dictKey
      });
      Vue.abTools.getResultData(post, data => {
        var json = {};
            if(data && data.length>0){
                for(var i = 0 ; i < data.length ; i++){
                    json[data[i].key] = data[i].name;
                }
            }
          fn && fn(json);
      });
}

/**
 * 通过scope中取得ng-model对应的属性值
 *
 * @param obj 控件对象
 * @param exp 表示ngModel （可选） 列如 a.b.c.d
 * @param scope （可选）
 * @returns
 */
window.getValByScope = function (option) {

    var scope = option.scope;
    var exp = option.exp;
    var obj = option.obj;

    if ( obj )
        obj = angular.element ( obj );

    if ( !scope && !obj )
        return;
    scope = scope || obj.scope ( );
    var ngModel = exp || ( obj && ( obj.attr ( "ng-model" ) ) );
    if ( !ngModel ) {
        if ( obj && ( obj.attr ( "type" ) == "checkbox" || obj.attr ( "type" ) == "radio" ) ) {
            if ( obj.is ( ":checked" ) )
                return obj.val ( );
            else
                return "";
        } else
            return obj.val ( );
    }
    try {
        if ( scope ) {
            var str = "scope." + ngModel;
            return eval ( "(" + str + ")" );
        } else {
            return obj.val ( );
        }
    } catch ( e ) {
        return "";
    }
}

/**
 * 移除数组中指定对象
 */
Array.prototype.remove = function(val) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] === val) {
            this.splice(i, 1);
            i--;
        }
    }
    return this;
};
Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
    return this;
};

Array.prototype.indexOf = function ( e ) {

    for ( var i = 0 , j ; j = this[i] ; i++ ) {
        if ( j == e ) {
            return i;
        }
    }
    return -1;
};

Array.prototype.pushAll = function ( list , types ) {
    if ( list && ( list instanceof Array ) && list.length > 0 ) {
        for ( var i = 0 ; i < list.length ; i++ ) {
            if ( types ) {
                var isMatch = false;
                for ( var j = 0 ; j < types.length ; j++ ) {
                    if ( typeof list[i] == types[j] ) {
                        isMatch = true;
                        break;
                    }
                }
                if ( !isMatch ) {
                    continue;
                }
            }
            this.push ( list[i] );
        }
    }
    return this;
};

//产生随机数
window.GetRandomNum = function(Min, Max) {
    var Range = Max - Min;
    var Rand = Math.random();
    return (Min + Math.round(Rand * Range));
}
//随机从列表中获取一个值
window.GetRandomList = function(list) {
    if ( !list )
        return "";
    if ( typeof list == "string" ) {
        list = JsonUtil.ps ( list );
    }
    var v = list[GetRandomNum (0, list.length-1 )];
    return v;
}
window.isStrNull = function( str ) {
    return str === "" || str === null || str === undefined;
}
//产生随机字符串
window.GetRandomStr = function(len) {
　　len = len || 32;
　　var $chars = 'ABCDEFGHJKLMNOPQRSTUVWXYZabcdefhijklmnoprstuvwxyz';
　　var maxPos = $chars.length;
　　var pwd = '';
　　for (var i = 0; i < len; i++) {
　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
　　}
　　return pwd;
}

window.copyObj = function (obj) {

    if(!obj){
        return null;
    }

    try{
        return JSON.parse(JSON.stringify(obj));
    }catch(e){
    }

        // hash表，记录所有的对象的引用关系
        let map = new WeakMap ( );
        function dp ( obj ) {

            let result = null;
            let keys = Object.keys ( obj );
            let key = null , temp = null , existobj = null;

            existobj = map.get ( obj );
            // 如果这个对象已经被记录则直接返回
            if ( existobj ) {
                return existobj;
            }

            result = {}
            if(obj instanceof Array){
                result = [];
            }
            map.set ( obj , result );

            for ( let i = 0 , len = keys.length ; i < len ; i++ ) {
                key = keys[i];
                temp = obj[key];
                if ( temp && typeof temp === 'object' ) {
                    result[key] = dp ( temp );
                } else {
                    result[key] = temp;
                }
            }
            return result;
        }
        var target =  dp ( obj );


    return target;
}

window.getHtmlText = function (html) {
    if(!html){
        return "";
    }
    var oDiv = document.createElement('div');
    oDiv.innerHTML = html;
    var text = oDiv.innerText;
    return text;
}
window.mergeObj = function (obj1,obj2) {
    return Object.assign(obj1,obj2);
}
// 计算高度
window.calcHeight = function (el,subHeight) {
    var h = document.body.clientHeight-subHeight;
    document.querySelectorAll(el).forEach(function(i,e){
        i.style.height = h + "px";
    });
}
// 处理树节点的一些信息
window.setTreeDataListInfo = function(treeDataList,titleKey){
    function getTickMenuId(obj){
        if(undefined == obj || null == obj || !obj instanceof Object){
            return;
        }
        if(obj.children && obj.children.length){
            obj.hasChildren = true;
            obj.expand = true;
        }
        obj.title = obj[titleKey] || obj.title;
        if(null != obj.children && obj.children instanceof Array){
            for(let child of obj.children){
                getTickMenuId(child);
            }
        }
    }
    treeDataList.forEach((item)=>{
        getTickMenuId(item)
    })

}

// 将普通列表转换为树结构的列表
window.listToTreeList = function(list,idKey, pidKey) { 
    if (!list || !list.length) {
        return []
    }
    idKey = idKey || "id";
    pidKey = pidKey || "pid";
    let treeListMap = {};
    for (let item of list) {
        treeListMap[item[idKey]] = item
    }
    for (let i = 0; i < list.length; i++) {
        if (list[i][pidKey] && treeListMap[list[i][pidKey]]) {
            if (!treeListMap[list[i][pidKey]].children) {
                treeListMap[list[i][pidKey]].children = []
            }
            treeListMap[list[i][pidKey]].children.push(list[i]);
            list.splice(i, 1);
            i--
        }
    }
    return list
}

//根据key获取数据,并且忽略大小写和驼峰
window.getDataByKey = function(data,key){
    data = JsonUtil.ps(data);
    if(!data||!key) return "";
    key = key+"";
    key = key.trim();
    if(data[key]) return data[key];
    if(data[key.toLowerCase()]) return data[key.toLowerCase()];
    if(data[key.tuoFeng()]) return data[key.tuoFeng()];
    if(data[key.toLowerCase().tuoFeng()]) return data[key.toLowerCase().tuoFeng()];
    return "";
}

// 修改标题
// 只需要在data中定义
/*  __title:{
    addTitle:"新增时的标题", // 新增时的标题
    editTitleKey:"typeName",// 编辑或者详情时的标题拼接字段
    }
    */
window.updateEditPageTitle = function (vnode,result) {
    if(vnode.context && vnode.context._data.__title && vnode.context._data.__title && vnode.context._data.__title.editTitleKey && vnode.context.$route.meta){
        var title = result.data[vnode.context._data.__title.editTitleKey] || "";
        if(title.length>20){
          title = title.substring(0,20) + "...";
        }
        vnode.context.$store.dispatch('admin/page/currentUpdate', {
            meta: {
                title:  vnode.context.$route.meta.title + "-" + title
            }
        });
    }
}

let $ = $ || {};
// $.Dialog.error("")
// $.Dialog.success("")
$.Dialog = {
    error : function (msg) {
        Vue.prototype.$Message.error({
            content: msg,
            closable: true,
            duration: 3
        });
    },
    success : function (msg) {
        Vue.prototype.$Message.success({
            content: msg,
            closable: true,
            duration: 3
        });
    }
}
window.$ = $;

/**
 * 将字符串转为json对象。
 * @param jsonStr
 * @param type  可不填写
 * @returns
 */
window.parseToJson = function(jsonStr){
    if(jsonStr === "") return ;
    return util.JsonUtil.ps(jsonStr);
}
window.JsonUtil = util.JsonUtil;
window.ps = window.parseToJson;


export { requestAnimation };

export default util;
